import React from 'react'

import NotFound from '../../components/NotFound'
import Project from '../../components/Projects/ProjectsPage'
import { fetchProjectData } from '../../data/server/query-transform/fetchProjectData'

const ProjectsPage = ({ data, error }) => {
  if (error || !data?.[0]?.fields) {
    return <NotFound />
  }

  return <Project data={data} />
}

export async function getServerSideProps(context) {
  return await fetchProjectData({ slug: context?.params?.slug, context, isPreview: false })
}

export default ProjectsPage
